import AttendanceAdapter from './base';

export default class AlertLog extends AttendanceAdapter {
  modelNamePlural = 'alertLogs';
}
